<script setup lang="ts">
import { VForm } from 'vuetify/components/VForm'
import { useAuthStore } from '@/pages/admin/auth/login/store/useAuthStore'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import logo from '@images/logo-right.png'
import logoDark from '@images/logo-right-white.png'
import background from '@images/pages/background.png'

const themeLogo = useGenerateImageVariant(logo, logoDark)

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const authStore = useAuthStore()

const {
  credentials,
  login,
} = authStore

const {
  form,
  loading,
} = storeToRefs(authStore)

const isPasswordVisible = ref(false)
</script>

<template>
  <VRow
    no-gutters
    class="auth-wrapper"
  >
    <VCol
      md="8"
      class="d-none d-md-flex"
    >
      <div class="position-relative w-100 ma-8 me-0">
        <div class="d-flex align-center justify-center w-100 h-100 position-relative">
          <VImg
            :src="background"
            class="auth-illustration rounded-lg"
          />
        </div>
      </div>
    </VCol>
    <VCol
      cols="12"
      md="4"
      class="auth-card-v2 d-flex align-center justify-center"
    >
      <VCard
        flat
        width="100%"
        :max-width="500"
        class="mt-12 mt-sm-0 pa-4"
      >
        <VCardText>
          <a href="/">
            <VImg
              :src="themeLogo"
              class="mb-2 logo d-flex justify-center"
              alt="Connect Eventos"
            />
          </a>
          <p class="text-center mb-0">
            Faça login em sua conta
          </p>
        </VCardText>

        <VCardText>
          <VForm ref="form">
            <VRow>
              <VCol cols="12">
                <AppTextField
                  v-model="credentials.email"
                  autofocus
                  label="E-mail"
                  type="email"
                  placeholder="Insira seu E-mail"
                />
              </VCol>

              <VCol cols="12">
                <AppTextField
                  v-model="credentials.password"
                  label="Senha"
                  placeholder="············"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                />

                <div class="d-flex align-center flex-wrap justify-space-between mt-2 mb-4">
                  <VCheckbox
                    v-model="credentials.remember"
                    label="Lembrar de mim"
                  />
                  <a
                    class="text-primary ms-2 mb-1"
                    href="/admin/auth/esqueceu-senha"
                  >
                    Esqueceu a senha?
                  </a>
                </div>

                <VBtn
                  block
                  :loading="loading"
                  @click="login(credentials)"
                >
                  Entrar
                </VBtn>
              </VCol>

              <VCol
                cols="12"
                class="text-center text-base"
              >
                <span>Novo por aqui?</span>

                <a
                  class="text-primary ms-2"
                  href="/admin/auth/cadastrar"
                >
                  Crie uma conta
                </a>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth";
.logo{
  height: 80px;
}
</style>